import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, effect,
  inject,
  OnDestroy
} from "@angular/core";
import {EmergencyProcedureService} from "../emergencyprocedure.service";
import {EmergencyProcedure} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-emergency-procedure-settings',
  templateUrl: './emergency-procedure-settings.component.html',
  styleUrls: ['./emergency-procedure-settings.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class EmergencyProcedureSettingsComponent implements AfterViewInit, OnDestroy {

  confirmationText = '';
  statusMessage = '';
  success = false;

  editableEmergencyProcedures: EmergencyProcedure[] = [];

  readonly emergencyProcedureService = inject(EmergencyProcedureService);
  modalElement?: HTMLElement;
  onShowModal = () => this.prepareDialog();

  constructor() {
    effect(() => {
      this.editableEmergencyProcedures =
        this.emergencyProcedureService.emergencyProceduresResource
          .value()
          .map(ep => ({ ...ep }));
    });
  }

  ngAfterViewInit(): void {
    this.modalElement = document.getElementById('emergencyProcedureSettings') ?? undefined;
    this.modalElement?.addEventListener('show.bs.modal', this.onShowModal);
  }

  ngOnDestroy(): void {
    this.modalElement?.removeEventListener('show.bs.modal', this.onShowModal);
  }

  private prepareDialog(): void {
    this.confirmationText = '';
    this.statusMessage = '';
    this.emergencyProcedureService.emergencyProceduresResource.reload();
  }

  saveEmergencyProcedureSettings(): void {
    this.statusMessage = '';
    if (this.confirmationText.toLowerCase() !== 'change') {
      this.statusMessage = 'Please type CHANGE to confirm the modification.';
      this.success = false;
      return;
    }

    this.emergencyProcedureService.saveEmergencyProcedureSettings(this.editableEmergencyProcedures)
      .subscribe(result => {
        this.confirmationText = '';
        if (result) {
          this.success = true;
          this.statusMessage =
            'Emergency procedure status(es) saved successfully';
        } else {
          this.success = false;
          this.statusMessage =
            'Emergency procedure status(es) can not be saved';
        }
      });
  }
}
